<template>
  <div>
    <transition enter-active-class="fadeIn" leave-active-class="fadeOut" mode="out-in">
      <div
        v-show="showSuccess"
        class="sc-result-box sc-result-box-overlay"
        :style="`display: block;z-index:${highestZIndex + 8}`"
      >
        <div>
          <img :src="`${scBaseUrl}/assets/images/Purchase_Success.png`" alt="Payment Success" />
          <h2>Purchase Successful</h2>
          <!-- <p>Redirecting you so that you can access it{{ ".".repeat(ScRedirectLoader) }}</p> -->
          <p v-html="resultMessage"></p>
          <p>{{ ".".repeat(ScRedirectLoader) }}</p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    showSuccess: {
      type: [Boolean, Number],
      required: true,
    },
    resultMessage: {
      type: [String],
      required: true,
    },
  },
  data() {
    return {
      showSuccessOverlay: false,
      ScRedirectLoader: 3,
    };
  },
  mounted() {
    setInterval(() => {
      this.ScRedirectLoader++;
      if (this.ScRedirectLoader > 3) {
        this.ScRedirectLoader = 0;
      }
    }, 1000);
  },
  watch: {
    showSuccess() {
      if (!this.showSuccess) {
        this.showSuccessOverlay = this.showSuccess;
      } else {
        setTimeout(() => {
          this.showSuccessOverlay = this.showSuccess;
        }, 500);
      }
    },
  },
  methods: {
    toggleSuccess() {
      this.showSuccess = !this.showSuccess;
    },
  },
};
</script>



// WEBPACK FOOTER //
// PaySuccessComponent.vue?7bd81da8